import React from 'react';

/**
 * Injects JSON-LD structured data into the document head.
 * Kept purposefully lightweight — no react-helmet dependency.
 */
export const Seo = ({ title, description, jsonLd }) => {
  React.useEffect(() => {
    if (title) document.title = title;

    // Description meta
    if (description) {
      let el = document.querySelector('meta[name="description"]');
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', 'description');
        document.head.appendChild(el);
      }
      el.setAttribute('content', description);
    }

    // Structured data
    if (jsonLd) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-seo', 'page');
      script.textContent = JSON.stringify(jsonLd);
      // Remove previous page-level JSON-LD
      document
        .querySelectorAll('script[data-seo="page"]')
        .forEach((s) => s.remove());
      document.head.appendChild(script);

      return () => {
        script.remove();
      };
    }
    return undefined;
  }, [title, description, jsonLd]);

  return null;
};

export default Seo;
